var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableCdw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.982 12.862v-1.904H1.137v1.904h1.845zM.692 14A.697.697 0 0 1 0 13.298v-2.776a.7.7 0 0 1 .692-.702h2.736a.7.7 0 0 1 .691.702v2.776a.7.7 0 0 1-.691.702H.692zm7.23-1.138v-1.904H6.078v1.904h1.844zM8.368 14H5.632a.7.7 0 0 1-.692-.702v-2.776a.7.7 0 0 1 .692-.702h2.736a.7.7 0 0 1 .692.702v2.776a.7.7 0 0 1-.692.702zM2.982 7.951V6.046H1.137v1.905h1.845zM.692 9.09A.7.7 0 0 1 0 8.387V5.61a.7.7 0 0 1 .692-.702h2.736a.7.7 0 0 1 .691.702v2.777a.7.7 0 0 1-.691.702H.692zm0-4.909A.7.7 0 0 1 0 3.478V.702A.7.7 0 0 1 .692 0h12.614a.7.7 0 0 1 .692.702v2.776a.7.7 0 0 1-.692.702H.692zm7.23 3.771V6.046H6.078v1.905h1.844zm.446 1.138H5.632a.7.7 0 0 1-.692-.702V5.61a.7.7 0 0 1 .692-.702h2.736a.7.7 0 0 1 .692.702v2.777a.7.7 0 0 1-.692.702zm4.454-1.138V6.046h-1.844v1.905h1.844zm.446 1.138h-2.736a.7.7 0 0 1-.692-.702V5.61a.7.7 0 0 1 .692-.702h2.736a.7.7 0 0 1 .692.702v2.777a.7.7 0 0 1-.692.702zm-.405 3.773v-1.904h-1.845v1.904h1.845zM13.308 14h-2.736a.7.7 0 0 1-.691-.702v-2.776a.7.7 0 0 1 .691-.702h2.736a.7.7 0 0 1 .692.702v2.776a.7.7 0 0 1-.692.702z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableCdw);
export default __webpack_public_path__ + "static/media/table-cdw.8e874806f747ac923edf00956d7a2808.svg";
export { ForwardRef as ReactComponent };